import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {Modal} from 'react-bootstrap'
import moment from 'moment'

const ShareVideoPreView = ({data}: any) => {
  const intl = useIntl()
  const [downloading, setDownloading] = useState<boolean>(false)
  const [content, setContent] = useState<React.ReactNode>(null)

  const downloadMP4 = async (videoUrl: string) => {
    setDownloading(true)

    try {
      const pathname = new URL(videoUrl).pathname
      const fileName = pathname.substring(pathname.lastIndexOf('/') + 1)

      const response = await fetch(videoUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error(`Failed to fetch file: ${response.statusText}`)
      }
      const blob = await response.blob()
      const downloadUrl = window.URL.createObjectURL(blob)

      const anchor = document.createElement('a')
      anchor.href = downloadUrl
      anchor.download = fileName
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
      window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      console.error('Error downloading file:', error)
    } finally {
      setDownloading(false)
    }
  }

  const downloadMDT = (video: any) => {
    const fileUrl = video
    const pathname = new URL(fileUrl).pathname
    const fileName = pathname.substring(pathname.lastIndexOf('/') + 1)
    const anchor = document.createElement('a')
    anchor.href = fileUrl
    anchor.download = fileName
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  }

  const extractExtension = (url: string) => {
    try {
      const pathname = new URL(url).pathname
      const lastSegment = pathname.substring(pathname.lastIndexOf('/') + 1)
      const dotIndex = lastSegment.lastIndexOf('.')
      return dotIndex !== -1 ? lastSegment.substring(dotIndex + 1) : ''
    } catch {
      return ''
    }
  }
  const formatDateTime = (StartEpoch: any, EndEpoch: any) => {
    const startMoment = moment.unix(StartEpoch)
    const endMoment = moment.unix(EndEpoch)
    const datePart = startMoment.format('YYYY-MM-DD')
    const startTime = startMoment.format('HH:mm:ss')
    const endTime = endMoment.format('HH:mm:ss')

    const formatted = `${datePart} | ${startTime} - ${endTime}`
    return formatted
  }

  useEffect(() => {
    const extension = extractExtension(data?.Url)
    if (extension.toLowerCase() === 'mp4') {
      setContent(
        <React.Fragment>
          <div
            className='fw-normal mb-2 d-flex align-items-center justify-content-between'
            style={{fontSize: 12, lineHeight: '18px'}}
          >
            <div>
              <span className='fw-bolder'>{intl.formatMessage({id: 'DEVICE.RECORDED_VIDEO'})}</span>
              : <span className='fw-bold'>{formatDateTime(data?.StartEpoch, data?.EndEpoch)}</span>
            </div>
            <div className='download-video'>
              {downloading ? (
                <span className='spinner-border spinner-border-sm text-primary align-middle'></span>
              ) : (
                <KTSVG
                  path='/media/icons/duotone/General/Requestfile.svg'
                  className='request-file'
                />
              )}
              <span
                className='link-primary text-break text-underline fw-bolder'
                onClick={(e) => {
                  e.stopPropagation()
                  downloadMP4(data?.Url)
                }}
              >
                {intl.formatMessage({id: 'DEVICE.DOWNLOAD_MP4-VIDEO'})}
              </span>
            </div>
          </div>

          <div className='responsive-video-container'>
            <video src={data?.Url} controls className='responsive-video'>
              {intl.formatMessage({id: 'TOOLTIP.YOUR_BROWSER_DOES_NOT_SUPPORT_THE_VIDEO_TAG'})}.
            </video>
          </div>
        </React.Fragment>
      )
    } else {
      setContent(
        <React.Fragment>
          <div className='mdt-links-container'>
            <div
              className='fw-normal d-flex align-items-center'
              style={{fontSize: 12, lineHeight: '18px'}}
            >
              <span className='fw-bolder'>{intl.formatMessage({id: 'DEVICE.RECORDED_VIDEO'})}</span>
              : {formatDateTime(data?.StartEpoch, data?.EndEpoch)}
            </div>
            <div className='download-mdt'>
              <KTSVG path='/media/icons/duotone/General/Requestfile.svg' className='request-file' />
              <span
                className='link-primary text-break text-underline'
                onClick={(e) => {
                  e.stopPropagation()
                  downloadMDT(data?.Url)
                }}
              >
                {intl.formatMessage({id: 'DEVICE.DOWNLOAD_MDT-VIDEO'})}
              </span>
            </div>
          </div>
        </React.Fragment>
      )
    }
  }, [data])

  return (
    <>
      <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom auth-bg position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
        {/* begin::Content */}
        <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
          {/* begin::Wrapper */}
          <Modal className='web-socket-modal video-player' show={true} centered>
            <Modal.Body>
              <div className='d-flex w-100 align-items-center justify-content-between mb-5'>
                <h1 className='text-primary d-flex gap-3 align-items-center'>
                  {intl.formatMessage({id: 'DEVICE.RECORDED_VIDEO'})}
                </h1>
              </div>
              <div className='d-flex gap-5 align-items-center mb-5'>
                {/* <span>
                  <span className='fw-bolder'>Vehicle No</span>:{' '}
                  <label className='form-label fs-6 text-dark m-0'>{'fdfdsfsdfsdfsd'}</label>
                </span> */}
                <div>
                  <span className='fw-bolder'>
                    {intl.formatMessage({id: 'GENERAL.LABEL.DEVICE_VEHICLE_NO'})}
                  </span>
                  : <span className='fs-6 m-0 text-gray-600'>{data?.VehicleNumber}</span>
                </div>
                <div>
                  <span className='fw-bolder'>
                    {intl.formatMessage({id: 'GENERAL.LABEL.DEVICE_NO'})}
                  </span>
                  : <span className='fs-6 m-0 text-gray-600'>{data?.DeviceId}</span>
                </div>
              </div>
              <div
                className='line-break w-100 my-5'
                style={{backgroundColor: '#EFF2F5', height: 1}}
              />
              {content}
            </Modal.Body>
          </Modal>
          {/* end::Wrapper */}
        </div>
        {/* end::Content */}
        {/* begin::Footer */}

        {/* end::Footer */}
      </div>
    </>
  )
}

export default ShareVideoPreView
